// @core/api/endpoints/userprofile/list_userprofiles.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListUserprofilesResponse,
} from '../../../types/userprofile';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/userprofile';

/**
 * List user profiles with filters (respects privacy settings)
 * Returns a paginated list of user profiles matching the specified filters. Results are filtered based on each profile's privacy settings relative to the caller.
 */
export async function ListUserprofiles(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListUserprofilesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/`;
  const requestOptions = options;
  return client.get<ListUserprofilesResponse>(requestPath, { ...requestOptions, params });
}
